module.exports = "<p>\n  auth-success works!\n</p>\n"